/*
  router/index.js
*/

import Vue from 'vue'
import VueRouter from 'vue-router'
import { sLog } from '@/common/simple-logger'

import Login from '@/components/Login'
import MainContent from '@/components/MainContent'
import WhereaboutsList from '@/components/WhereaboutsList'
import SelectedWhereaboutsInfo from '@/components/SelectedWhereaboutsInfo'
import MapLocation from '@/components/MapLocation'
import NotFound from '@/components/NotFound'
import { ROUTE_NAME, ROUTE_PATH } from '@/router/routes'
import store from '@/store/'

Vue.use(VueRouter)

// routeの定義
const routes = [
  // login画面
  {
    name: ROUTE_NAME.ROUTE_LOGIN,
    path: ROUTE_PATH.ROUTE_LOGIN,
    component: Login,
    props: true,
  },
  // Contents画面(login後画面)
  // @Memo Routerのネストには、childrenを使う
  {
    name: ROUTE_NAME.ROUTE_MAIN_CONTENT,
    path: ROUTE_PATH.ROUTE_MAIN_CONTENT,
    component: MainContent,
    props: true,
    meta: {
      requiresAuth: true
    },
    children: [
      // 場所情報一覧画面
      {
        name: ROUTE_NAME.ROUTE_WHEREABOUTS_LIST,
        path: ROUTE_PATH.ROUTE_WHEREABOUTS_LIST,
        component: WhereaboutsList,
        props: true,
        /*
        meta: {
          requiresAuth: true
        }
        */
      },
      // 行動予定情報画面
      {
        name: ROUTE_NAME.ROUTE_WHEREABOUTS_INFO,
        path: ROUTE_PATH.ROUTE_WHEREABOUTS_INFO_ID,
        component: SelectedWhereaboutsInfo,
        props: true,
        /*
        meta: {
          requiresAuth: true
        }
        */
      },
      // 地図位置情報画面
      {
        name: ROUTE_NAME.ROUTE_MAP_LOCATION,
        path: ROUTE_PATH.ROUTE_MAP_LOCATION,
        component: MapLocation,
        props: true
      },
    ]
  },
  { path: '*', component: NotFound },
]

// @Memo IE11では:の省略形でエラーになる
const router = new VueRouter({
  mode: 'history',
  routes: routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    else {
      return { x: 0, y: 0 }
    }
  },
})

// ログイン認証
router.beforeEach((to, from, next) => {
  // 未認証の場合は、ログイン画面にRoutingする
  sLog.debug('@router ' + store.getters.isLoggedIn)
  //sLog.debug(from)
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.isLoggedIn) {
      next({path: ROUTE_PATH.ROUTE_LOGIN, query: { redirect: to.fullPath }})
    } else {
      // BackキーでMainContentに戻ったらアプリを終了する
      if ((from.name.match(/Login/) === null) && (to.name.match(/MainContent/) !== null)) {
        navigator.app && navigator.app.exitApp && navigator.app.exitApp()
      }
      next()
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js